import { useParams } from "react-router-dom";
const appNameObj = {
  "spoty-parking": "Spoty Parking",
  "guia-de-bolso-cristao": "Guia de Bolso",
  freshcura: "Freshcura",
  "little-pilgrim": "Little Pilgrim",
  default: "Castro e Mello Apps",
};

export default function DeleteAccount() {
  let { app } = useParams<{ app: keyof typeof appNameObj }>();
  console.log(app);
  // app -> spoty-parking
  // app -> guia-de-bolso-cristao
  //   const appName = appNameObj[app || "default"];

  return (
    <div className="container px-4 mx-auto sm:px-6 lg:px-8 mb-12">
      <br />

      <h1 className="text-2xl font-extrabold leading-9 tracking-tight text-gray-800 sm:text-3xl 5xl:text-5xl sm:leading-10">
        Deletar conta da sua conta Little Pilgrim
      </h1>
      <div className="flex flex-col   justify-center">
        <div className="flex items-center">
          <img
            alt="Example of app being used on main screens"
            className="w-40 m-4"
            src="https://firebasestorage.googleapis.com/v0/b/little-pilgrim.appspot.com/o/site%2Faccoundelete.png?alt=media&token=f538c2f6-1f94-46fd-8e0f-67021bb2a229"
          />
          <h1 className="text-xl font-extrabold leading-9 tracking-tight text-gray-800 sm:text-xl xl:text-xl sm:leading-10">
            Dentro do aplicativo, em Conta e apertando em Deletar conta, você
            pode deletar sua conta.
          </h1>
        </div>
        <div className="flex items-center">
          <img
            alt="Example of app being used on main screens"
            className="w-40 m-4"
            src="https://firebasestorage.googleapis.com/v0/b/little-pilgrim.appspot.com/o/site%2Fdeleting.png?alt=media&token=b44ecca3-1363-48f8-a303-ac4828a39728"
          />
          <h1 className="text-xl font-extrabold leading-9 tracking-tight text-gray-800 sm:text-xl xl:text-xl sm:leading-10">
            Você precisará fazer o login novamente para confirmar a exclusão da
            sua conta.
          </h1>
        </div>
        <h1 className="text-xl font-extrabold leading-9 tracking-tight text-gray-800 sm:text-xl xl:text-xl sm:leading-10">
          Quando você deleta sua conta, todos os seus dados pessoais são
          apagados
        </h1>
      </div>
      <br />
    </div>
  );
}
